import type { CSSProperties } from 'react';

export const BRAND = '#0F9599';
export const BRAND_DARK = '#0F6E56';
export const BRAND_SOFT = '#E1F5EE';
export const TEXT_PRIMARY = '#111827';
export const TEXT_INK = '#1A2B2B';
export const TEXT_SECONDARY = '#12262B';
export const TEXT_TERTIARY = '#12262B';
export const BG_CARD = '#FFFFFF';
export const BG_PAGE = '#F7F9F9';
export const BORDER = '#E5E7EB';
export const BORDER_LIGHT = '#F0F4F4';
export const WARN_TEXT = '#92400E';
export const WARN_SOFT = '#FEF3C7';
export const WARN_DOT = '#E8941A';
export const SUCCESS_TEXT = '#166534';
export const SUCCESS_SOFT = '#DCFCE7';

export const TH: CSSProperties = {
  background: BG_PAGE,
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.04em',
  color: TEXT_SECONDARY,
  textAlign: 'left',
  padding: '12px 16px',
  borderBottom: '0.5px solid ' + BORDER,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
};

export const TD: CSSProperties = {
  padding: '14px 16px',
  fontSize: 14,
  color: TEXT_PRIMARY,
  borderBottom: '0.5px solid ' + BORDER_LIGHT,
  verticalAlign: 'middle',
};

export const MASK: CSSProperties = {
  letterSpacing: 2,
  color: TEXT_TERTIARY,
  fontSize: 14,
};

export const MISS: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  fontSize: 12.5,
  fontWeight: 600,
  color: WARN_TEXT,
  cursor: 'pointer',
};